export default () => (
  <svg viewBox="0 0 27 29.2">
    <path
      d="M7.83147 2.36762C10.5979 0.789206 11.9811 0 13.5 0C15.0189 0 16.4021 0.789206 19.1685 2.36762L21.3315 3.6017C24.0979 5.18011 25.4811 5.96932 26.2406 7.26923C27 8.56914 27 10.1476 27 13.3044V15.7725C27 18.9294 27 20.5078 26.2406 21.8077C25.4811 23.1076 24.0979 23.8968 21.3315 25.4752L19.1685 26.7093C16.4021 28.2877 15.0189 29.0769 13.5 29.0769C11.9811 29.0769 10.5979 28.2877 7.83147 26.7093L5.66853 25.4752C2.9021 23.8968 1.51888 23.1076 0.759439 21.8077C0 20.5078 0 18.9294 0 15.7725V13.3044C0 10.1476 0 8.56914 0.759439 7.26923C1.51888 5.96932 2.9021 5.18011 5.66853 3.6017L7.83147 2.36762Z"
      fill="#121212"
    />
  </svg>
);
